import { featureFlags, featureFlagsUtils } from '../config/featureFlags';

/**
 * Headers that identify this browser app as the Retail or Admin portal.
 * Java ClientAppGateFilter validates these when security.client-gate.enabled=true.
 */
export function getClientAppGateHeaders(): Record<string, string> {
  const isAdmin = featureFlagsUtils.isAdminContext();
  return {
    'X-Client-App': isAdmin ? 'admin' : 'retail',
    'X-Client-Key': isAdmin
      ? featureFlags.general.clientAdminKey
      : featureFlags.general.clientRetailKey,
  };
}
